// extracted by mini-css-extract-plugin
export var filtersTaxo = "listResults-module--filters-taxo--0dd3c";
export var listResult = "listResults-module--list-result--9a0c0";
export var resultContent = "listResults-module--result-content--652ef";
export var resultItem = "listResults-module--result-item--9985a";
export var resultResume = "listResults-module--result-resume--a40e3";
export var resultTitle = "listResults-module--result-title--5b9b8";
export var resultType = "listResults-module--result-type--649f6";
export var resultTypeIcon = "listResults-module--result-type-icon--8d1ce";
export var resultTypeType = "listResults-module--result-type-type--72706";
export var results = "listResults-module--results--964f4";
export var resultsContainer = "listResults-module--results-container--fa565";
export var resultsTop = "listResults-module--results-top--9f9bb";